// src/config.js
const config = {
    apiBaseUrl: process.env.REACT_APP_API_URL,
};

export default config;
